import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { successOpen, updateUser } from '@app-modules/feature/editprofile/editprofile.component';
// import { getSubjectsBasedOnExamtype } from '@app-modules/feature/self-learn/components/all-subjects/all-subjects.component';
import { BoardsService } from '@app-services/boarrds/boards.service';

@Component({
  selector: 'app-exam-focus-dialog',
  templateUrl: './exam-focus-dialog.component.html',
  styleUrls: ['./exam-focus-dialog.component.css']
})

export class ExamFocusDialogComponent implements OnInit {

  exams: any = [];
  searchIndices: any = [];
  allSearchIndices: any = [];
  index: any;
  greenTickPath = 'assets/img/green-tick-icon.svg';
  greyTickPath = '';
  examSelected: any;
  isclicked: boolean = false;

  constructor(
    private targetExamService: BoardsService,
    private router: Router,
    private dialogRef: MatDialogRef<ExamFocusDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    // dialogRef.disableClose = !this.data.isExamEdit;
  }

  ngOnInit(): void {
    this.examSelected = (localStorage.getItem('examName')) || (localStorage.getItem('targetExamName'))
    this.getTargetExamsList();
  }

  getTargetExamsList(): any {
    // this.targetExamService.fetchTargetExamList().subscribe((data: any) => {
    //   this.exams = data;
    //   for (let i = 0, len = data.length; i < len; i++) {
    //     this.searchIndices.push(i);
    //   }
    //   this.allSearchIndices = this.searchIndices;

    //   if (this.data.exams) {
    //     for (let i = 0, len = data.length; i < len; i++) {
    //       if (data[i].examId == this.data.exams[i].examId) {
    //         this.index = i;
    //         break;
    //       }
    //     }
    //   }
    // });

    let userDetails = JSON.parse(localStorage.getItem('user_details_from_server'));

    let exam_user = userDetails ? userDetails.exams : []
      this.exams = exam_user;
      for (let i = 0, len = exam_user.length; i < len; i++) {
        this.searchIndices.push(i);
      }
      this.allSearchIndices = this.searchIndices;

      if (this.data.exams) {
        for (let i = 0, len = exam_user.length; i < len; i++) {
          if (exam_user[i].examId == this.data.exams[i].examId) {
            this.index = i;
            break;
          }
        }
      }
  }

  saveIndex(i: any) {
    this.index = i;
    this.isclicked = true
  }

  conditionCheckForSelectedExam(i): any {
    if(this.isclicked){
      return this.index === i
    } else {
      return this.index === i || this.exams[i]?.name.replaceAll(' ', '')?.toUpperCase() == this.examSelected
    }
  }

  onConfirmClick() {
    // console.log(this.index,this.exams[this.index])
    if (this.data.isExamEdit) {

      if (this.index != undefined || this.index != null) {
        // getSubjectsBasedOnExamtype.call(this, [{ name: 'examId', value: this.exams[this.index].examId }], () => {
        //   successOpen.call(this, 'Profile Updated', `Focus exams information has been updated  successfully`,
        //     () => this.dialogRef.close(this.exams[this.index]));
        // })

        this.dialogRef.close(this.exams[this.index])
      } else {
        this.dialogRef.close()
      }
    }
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  navigateToEditProfile(): any {
    let userDetails = JSON.parse(localStorage.getItem('user_details_from_server'));
    this.dialogRef.close()
    let data = {
      exams: this.exams,
      grade: userDetails?.grade,
      isGradeEdit: false
    }
    localStorage.setItem('grade-stream-board-data', JSON.stringify(data));
    // this.router.navigate(['/myprofile/editProfile',userDetails.userId]);
    this.router.navigate(['/myprofile/target-exam']);
  }
}

